import { render, staticRenderFns } from "./list.vue?vue&type=template&id=48a7e390&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "../../../style/common-pc.scss?vue&type=style&index=0&id=48a7e390&prod&lang=scss&scoped=true&external"
import style1 from "./list.vue?vue&type=style&index=1&id=48a7e390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a7e390",
  null
  
)

export default component.exports